import { AbstractClient, CompositionClient } from "@/app/client";

export interface UserAIKeyterms {
  keyterms: string[];
}

export interface UserAIResponse {
  id: string;
  user_id: string;
  type: number;
  data: any;
  created_at: string;
  updated_at: string;
}

export default class APIUserAISub extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getKeyterms = async (): Promise<UserAIKeyterms> => {
    let res = await this._fetch({
      url: "/user-ai/keyterms",
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  createKeyterms = async (
    keyterms: UserAIKeyterms,
  ): Promise<UserAIResponse> => {
    let res = await this._fetch({
      url: "/user-ai/keyterms",
      method: "POST",
      body: keyterms,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  updateKeyterms = async (
    keyterms: UserAIKeyterms,
  ): Promise<UserAIResponse> => {
    let res = await this._fetch({
      url: "/user-ai/keyterms",
      method: "PUT",
      body: keyterms,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteKeyterms = async (): Promise<void> => {
    await this._fetch({
      url: "/user-ai/keyterms",
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
  };

  getDefaultKeyterms = async (): Promise<UserAIKeyterms> => {
    let res = await this._fetch({
      url: "/user-ai/keyterms/defaults",
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
